import ApiConfig from "../../Utils/Configs/apiConfig";
export const ProcessService = async (
  selectedClient: string,
  encryptedId: string,
) => {
  try {
    ApiConfig.setApplicationTypeId(encryptedId);

    const response = await ApiConfig.getInstance().get(
      `/Processing/get-all-processings/${selectedClient}`,
    );
    if (response.status === 200) {
      console.log(response.data.data);
      return response.data.data;
    }
    return [];
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      console.warn("404 Error: Resource not found. Returning an empty array.");
      return [];
    }
    console.warn(error.message || "An unexpected error occurred.");
    return [];
  }
};
